module.exports = __webpack_public_path__ + "img/popup_title_bangzhu_en_d6b8204d4.png";